import React, { Component } from 'react';
import config from 'react-global-configuration';
import $ from 'jquery';
import * as moment from 'moment';
import { isApiResponse } from '../helpers/utils.js';
import MultiCsvReportDownload from '../components/DownloadReport/MultiCsvReportDownload.jsx';
import './TicketReport.css';

function formatLabel(label) {
  return label
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
}

class PerformanceTrendingMetricTab extends Component {
  constructor(props) {
    super(props);
    this._dt = null;
    this.state = {
      showDetails: false,
      selectedMetric: null,
      selectedColumnType: null,
      detailsData: []
    };
  }

  componentDidMount() {
    if (this.props.shouldLoadData) {
      this.get_filtered_performance_trending_metric();
      this.props.onDataLoaded();
    }
  }

  componentDidUpdate(prevProps) {
    console.log('MetricTab componentDidUpdate called');
    console.log('Current shouldLoadData:', this.props.shouldLoadData);
    console.log('Previous shouldLoadData:', prevProps.shouldLoadData);

    if (this.props.shouldLoadData && !prevProps.shouldLoadData) {
      console.log('Condition met - calling API');
      this.get_filtered_performance_trending_metric();
    }

    // Also reload on filter changes
    if (
      prevProps.merchantID !== this.props.merchantID ||
      prevProps.chainID !== this.props.chainID ||
      prevProps.storeID !== this.props.storeID ||
      prevProps.yestSend !== this.props.yestSend ||
      prevProps.todSend !== this.props.todSend ||
      prevProps.cf_issue_sub_category !== this.props.cf_issue_sub_category ||
      prevProps.city !== this.props.city ||
      prevProps.channel !== this.props.channel ||
      prevProps.product !== this.props.product ||
      prevProps.team !== this.props.team
    ) {
      this.get_filtered_performance_trending_metric();
    }
  }

  componentWillUnmount() {
    if ($.fn.DataTable.isDataTable('#metricTable')) {
      $('#metricTable').DataTable().clear().destroy();
    }
  }

  get_filtered_performance_trending_metric() {
    var that = this;
    if (this.props.shouldLoadData) {
      const postData = {
        start_date: this.props.yestSend,
        end_date: this.props.todSend,
        merchant: this.props.merchantID || [],
        chain: this.props.chainID || [],
        store: this.props.storeID || [],
        issue_category: this.props.cf_issue_sub_category || [],
        city: this.props.city || [],
        channel: this.props.channel || [],
        product: this.props.product || [],
        team: this.props.team || [],
        report_code: 'performance_trending_metric',
        download: 0
      };

      isApiResponse(false);

      if ($.fn.DataTable.isDataTable('#metricTable')) {
        $('#metricTable').DataTable().clear().destroy();
      }

      var metricTable = $('#metricTable').DataTable({
        order: [],
        processing: true,
        serverSide: true,
        bDestroy: true,
        paging: true,
        pageLength: 5,
        bInfo: false,
        responsive: false,
        scrollX: true,
        lengthMenu: [[5, 25, 50, 100, 500], [5, 25, 50, 100, 500]],
        fixedColumns: {
          leftColumns: 1
        },
        ajax: {
          url: config.get('API_URL') + '/ServiceReport/performance_trending_metric',
          type: 'POST',
          data: postData,
          dataSrc: function (json) {
            isApiResponse(true);
            that.setState({
              isChange: false
            });
            return json.data;
          },
          beforeSend: function (request) {
            request.setRequestHeader('Authorization', localStorage.usertoken);
          },
          error: function (data) {
            isApiResponse(true);
            alert('Failed to load data. Please try again');
            console.log('error', data);
          },
          complete: function (data) {
            isApiResponse(true);
            console.log('complete', data);
          }
        },
        columns: [
          { data: 'Tickets Added', width: '100px' },
          { data: 'Opening Balance', width: '100px' },
          { data: 'Tickets Added', width: '100px' },
          // Within TAT
          { data: 'Within TAT - Tickets Resolved', width: '100px', className: 'text-center' },
          { data: 'Within TAT - Tickets QC Closed', width: '120px', className: 'text-center' },
          { data: 'Within TAT - Tickets Open', width: '100px', className: 'text-center' },
          // Outside TAT
          { data: 'Outside TAT - Tickets Resolved', width: '100px', className: 'text-center' },
          { data: 'Outside TAT - Tickets QC Closed', width: '120px', className: 'text-center' },
          { data: 'Outside TAT - Tickets Open', width: '100px', className: 'text-center' },
          // Closing Balance
          { data: 'Closing Balance (Resolved but Not QC Closed)', width: '150px', className: 'text-center' },
          { data: 'Closing Balance Open', width: '120px', className: 'text-center' },
          // Percentages
          { data: '% Tickets Resolved Within TAT', width: '100px', className: 'text-center' },
          { data: '% Tickets QC Closed Within TAT', width: '120px', className: 'text-center' },
          // Repeat Tickets
          { data: 'Reopened ticket by customer or repeated from same subscription', width: '180px', className: 'text-center' },
          { data: '% of Repeat Tickets', width: '100px', className: 'text-center' }
        ],
        columnDefs: [
          {
            targets: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 13],
            createdCell: function (td, cellData, rowData, row, col) {
              if (cellData > 0) {
                $(td).css({
                  cursor: 'pointer'
                });
                $(td).on('click', function () {
                  that.handleCellClick(rowData, col);
                });
              }
            }
          },
          {
            targets: [11, 12, 14], // Percentage columns
            render: function (data) {
              return data == null ? '0%' : data + '%';
            }
          }
        ]
      });
    }
  }

  handleCellClick(rowData, colIndex) {
    console.log('Metric clicked:', rowData, colIndex);

    const columnTypeMap = {
      0: 'tickets_added',
      1: 'opening_balance',
      2: 'tickets_added',
      3: 'within_tat_resolved',
      4: 'within_tat_qc_closed',
      5: 'within_tat_open',
      6: 'outside_tat_resolved',
      7: 'outside_tat_qc_closed',
      8: 'outside_tat_open',
      9: 'closing_balance_resolved',
      10: 'closing_balance_open',
      // 11: % Tickets Resolved Within TAT - not clickable
      // 12: % Tickets QC Closed Within TAT - not clickable
      13: 'repeat_tickets'
      // 14: % of Repeat Tickets - not clickable
    };

    const columnType = columnTypeMap[colIndex];

    console.log('Column type:', columnType);

    this.setState({
      showDetails: true,
      selectedMetric: 'Overall Metrics',
      selectedColumnType: columnType
    }, () => {
      this.loadDetailsData();
    });
  }

  loadDetailsData() {
    const that = this;

    const postData = {
      start_date: this.props.yestSend,
      end_date: this.props.todSend,
      merchant: this.props.merchantID || [],
      chain: this.props.chainID || [],
      store: this.props.storeID || [],
      issue_category: this.props.cf_issue_sub_category || [],
      city: this.props.city || [],
      channel: this.props.channel || [],
      product: this.props.product || [],
      team: this.props.team || [],
      report_code: 'performance_trending_metric_details',
      column_type: this.state.selectedColumnType,
      download: 0
    };

    isApiResponse(false);

    if ($.fn.DataTable.isDataTable('#metricDetailsTable')) {
      $('#metricDetailsTable').DataTable().clear().destroy();
    }

    var detailsTable = $('#metricDetailsTable').DataTable({
      order: [[0, 'desc']],
      processing: true,
      serverSide: true,
      bDestroy: true,
      paging: true,
      pageLength: 5,
      bInfo: true,
      sPaginationType: 'simple_numbers',
      autoWidth: false,
      responsive: false,
      searching: true,
      lengthMenu: [[5, 25, 50, 100, 500], [5, 25, 50, 100, 500]],
      ajax: {
        url: config.get('API_URL') + '/ServiceReport/performance_trending_metric_details',
        type: 'POST',
        data: postData,
        dataSrc: function (json) {
          isApiResponse(true);
          return json.data;
        },
        beforeSend: function (request) {
          request.setRequestHeader('Authorization', localStorage.usertoken);
        },
        error: function (data) {
          isApiResponse(true);
          alert('Failed to load details. Please try again');
          console.log('error', data);
        },
        complete: function (data) {
          isApiResponse(true);
          console.log('complete', data);
        }
      },
      columns: [
        { data: 'Ticket Number', width: '100px' },
        { data: 'Product Name', width: '120px' },
        { data: 'Merchant Name', width: '180px' },
        { data: 'Store Name', width: '120px' },
        { data: 'Status', width: '100px' },
        { data: 'Date of Issue', width: '110px' },
{ data: 'Date of Resolved', width: '110px' },
{ data: 'Date of QC Close', width: '110px' },
{ data: 'TAT', width: '100px' },
        { data: 'Issue Category', width: '150px' },
        { data: 'Current Team Name', width: '120px' },
        { data: 'Current Team Member Name', width: '150px' },
        { data: 'Channel Name', width: '100px' }
      ],
      columnDefs: [
        {
            targets: 0, // Ticket Number column
            render: function (data) {
              const val = data == null ? '' : String(data);
              if (that.props.object_type === 'Innoviti') {
                return `<div class='text-wrap'>
                  <a href="https://innovitiservice.freshdesk.com/a/tickets/${val}"
                     target="_blank"
                     rel="noopener noreferrer"
                     style="color:#7b1fa2; text-decoration:underline;">
                    ${val}
                  </a>
                </div>`;
              }
              return `<div class='text-wrap'>${val}</div>`;
            }
          },
        {
          targets: '_all',
          render: function (data) {
            const val = data == null ? '' : String(data);
            return `<div class='text-wrap'>${val}</div>`;
          }
        }
      ]
    });
  }

  closeDetails() {
    this.setState({
      showDetails: false,
      selectedMetric: null,
      selectedColumnType: null
    });
  }

  TicketDetailsDownloadCheck(type, e) {
    var fn = 'performance_trending_metric_details.csv.gz';
    var url = '/service_reports/performance_trending_metric_details';
    var report_code = 'performance_trending_metric_details';

    let filters = {
      start_date: this.props.yestSend,
      end_date: this.props.todSend,
      download: 1,
      report_code: report_code,
      user_id: this.props.user_id,
      merchant: this.props.merchantID,
      chain: this.props.chainID || [],
      store: this.props.storeID,
      issue_category: this.props.cf_issue_sub_category,
      city: this.props.city,
      channel: this.props.channel,
      product: this.props.product,
      team: this.props.team,
      column_type: this.state.selectedColumnType
    };

    this.refs.downloadAllReport.downLoadReport(filters, url, fn, 190);
  }

  render() {
    const { showDetails, selectedMetric, selectedColumnType } = this.state;

    return (
      <div className="metric-tab-content service-report">
        <div className="content-tdetails-table table-full-width marginTop0">
          <table id="metricTable" className="table table-striped table-hover">
            <thead>
              <tr>
                <th rowSpan="2" className="merchant-header-default">Count of tickets</th>
                <th rowSpan="2" className="merchant-header-default">Opening Balance</th>
                <th rowSpan="2" className="merchant-header-default">Tickets Added</th>

                <th colSpan="3" className="merchant-header-default">Within TAT</th>

                <th colSpan="3" className="merchant-header-default">Outside TAT</th>

                <th rowSpan="2" className="merchant-header-default">Closing Balance Resolved but Not QC Closed</th>
                <th rowSpan="2" className="merchant-header-default">Closing Balance Open</th>
                <th rowSpan="2" className="merchant-header-default">% Tickets Resolved Within TAT</th>
                <th rowSpan="2" className="merchant-header-default">% Tickets QC Closed Within TAT</th>
                <th rowSpan="2" className="merchant-header-default">
                  Count of tickets re-opened by customer or repeated from same subscription
                </th>
                <th rowSpan="2" className="merchant-header-default">% of Repeat Tickets</th>
              </tr>

              <tr>
                <th className="merchant-header-default">No. Of Tickets Resolved</th>
                <th className="merchant-header-default">No. Of Tickets QC Closed</th>
                <th className="merchant-header-default">No. Of Tickets Open</th>

                <th className="merchant-header-default">No. Of Tickets Resolved</th>
                <th className="merchant-header-default">No. Of Tickets QC Closed</th>
                <th className="merchant-header-default">No. Of Tickets Open</th>
              </tr>
            </thead>
            <tbody>
            </tbody>
          </table>
        </div>

        {showDetails && (
          <div className="ticket-details-section" style={{ marginTop: '10px' }}>
            <div className="col-md-9 no-padd">
              <div className="details-header">
                <h3>
                  Ticket Details - {selectedMetric}
                  {selectedColumnType && ` (${formatLabel(selectedColumnType)})`}
                </h3>
                <hr />
              </div>
            </div>

            <div className="col-md-3 pull-right">
              <div className="r-p-menu">
                <div className="report-header-icons">
                  <div
                    className="icon-button download-icon"
                    title="Download Report"
                    onClick={this.TicketDetailsDownloadCheck.bind(this)}
                  >
                    <i className="fa fa-download"></i>
                  </div>
                  <div
                    className="icon-button print-icon"
                    title="Close Report"
                    onClick={() => this.closeDetails()}
                  >
                    <i className="fa fa-close"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="clearfix"></div>

            <div className="content-tdetails-table table-full-width table-responsive">
              <table id="metricDetailsTable" className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th className="merchant-header-default">Ticket Number</th>
                    <th className="merchant-header-default">Product Name</th>
                    <th className="merchant-header-default">Merchant Name</th>
                    <th className="merchant-header-default">Store Name</th>
                    <th className="merchant-header-default">Status</th>
                    <th className="merchant-header-default">Date of Issue</th>
<th className="merchant-header-default">Date of Resolved</th>
<th className="merchant-header-default">Date of QC Close</th>
<th className="merchant-header-default">TAT</th>
                    <th className="merchant-header-default">Issue Category</th>
                    <th className="merchant-header-default">Current Team Name</th>
                    <th className="merchant-header-default">Current Team Member Name</th>
                    <th className="merchant-header-default">Channel Name</th>
                  </tr>
                </thead>
                <tbody />
              </table>
            </div>
            <MultiCsvReportDownload ref="downloadAllReport" />
          </div>
        )}
      </div>
    );
  }
}

export default PerformanceTrendingMetricTab;